// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars */
import React, { useState, useEffect } from "react";
import { 
  UserPlus, MoreVertical, Shield, ShieldCheck, User, 
  Edit, Ban, Trash2, CheckCircle, Loader2, Clock, Key, Users,
  Search, ChevronLeft, ChevronRight
} from "lucide-react";
import InviteTeamModal from "../../components/modals/InviteTeamModal";

import { collection, onSnapshot, query, orderBy, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { db } from "../../config/firebase";

const AdminEquipePage = () => {
  // 🟢 Tipagem para blindar o TypeScript
  const [members, setMembers] = useState(/** @type {any[]} */ ([]));
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(/** @type {string | null} */ (null));
  
  const [memberToEdit, setMemberToEdit] = useState(/** @type {any | null} */ (null));
  
  // 🟢 States de Busca e Paginação
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  
  const brandColor = "#00a99d";
  const auth = getAuth(); 

  useEffect(() => {
    const q = query(collection(db, "team"), orderBy("createdAt", "desc"));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const teamData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setMembers(teamData);
      setLoading(false);
    }, (error) => {
      console.error("Erro ao buscar a equipe:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // 🟢 Reseta a página para 1 se pesquisar ou mudar a qtde de itens
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, itemsPerPage]);
  
  const handleToggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === 'Inativo' ? 'Ativo' : 'Inativo';
      const memberRef = doc(db, "team", id);
      await updateDoc(memberRef, { status: newStatus });
      setActiveDropdown(null);
    } catch (error) {
      console.error("Erro ao atualizar status:", error);
      alert("Erro ao atualizar o status do usuário.");
    }
  };

  const handleDeleteMember = async (id, name) => {
    if (window.confirm(`Atenção: Tem certeza que deseja remover permanentemente o acesso de ${name}?`)) {
      try {
        const memberRef = doc(db, "team", id);
        await deleteDoc(memberRef);
        setActiveDropdown(null);
      } catch (error) {
        console.error("Erro ao remover usuário:", error);
        alert("Erro ao remover o usuário do sistema.");
      }
    } else {
      setActiveDropdown(null);
    }
  };

  const handleResetPassword = async (email, name) => {
    if (window.confirm(`Deseja enviar um link de recuperação de senha para o e-mail de ${name} (${email})?`)) {
      try {
        await sendPasswordResetEmail(auth, email);
        alert(`✅ E-mail de redefinição de senha enviado com sucesso para ${email}.`);
        setActiveDropdown(null);
      } catch (error) {
        const err = /** @type {any} */ (error);
        console.error("Erro ao enviar e-mail de reset:", err);
        if (err.code === 'auth/user-not-found') {
          alert("Este usuário ainda não concluiu o cadastro inicial de senha no sistema.");
        } else {
          alert("Ocorreu um erro ao tentar enviar o e-mail de recuperação.");
        }
      }
    } else {
      setActiveDropdown(null);
    }
  };

  const handleEditClick = (member) => {
    setMemberToEdit(member);
    setIsModalOpen(true);
    setActiveDropdown(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setMemberToEdit(null); 
  };

  const renderRoleBadge = (role) => {
    switch (role) {
      case "master":
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-purple-50 text-purple-700 border border-purple-200">
            <ShieldCheck className="w-3.5 h-3.5 mr-1.5" /> Master
          </span>
        );
      case "financeiro":
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-blue-50 text-blue-700 border border-blue-200">
            <Shield className="w-3.5 h-3.5 mr-1.5" /> Financeiro
          </span>
        );
      case "operacional":
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-slate-100 text-slate-700 border border-slate-200">
            <User className="w-3.5 h-3.5 mr-1.5" /> Operacional
          </span>
        );
      default:
        return null;
    }
  };

  const renderStatusBadge = (status) => {
    if (status === 'Ativo') {
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-green-50 text-green-700 border border-green-200">
          <CheckCircle className="w-3.5 h-3.5 mr-1.5" /> Ativo
        </span>
      );
    }
    if (status === 'Pendente') {
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-amber-50 text-amber-700 border border-amber-200">
          <Clock className="w-3.5 h-3.5 mr-1.5" /> Pendente
        </span>
      );
    }
    return (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-red-50 text-red-700 border border-red-200">
        <Ban className="w-3.5 h-3.5 mr-1.5" /> Inativo
      </span>
    );
  };

  const toggleDropdown = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };

  // ==========================================
  // 🟢 Lógica de Filtro e Paginação
  // ==========================================
  const filteredMembers = members.filter(member => 
    member.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    member.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMembers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredMembers.length / itemsPerPage);

  const nextPage = () => { if (currentPage < totalPages) setCurrentPage(prev => prev + 1); };
  const prevPage = () => { if (currentPage > 1) setCurrentPage(prev => prev - 1); };

  // ============================================================================
  // SKELETON LOADER
  // ============================================================================
  if (loading) {
    return (
      <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto font-sans animate-pulse w-full">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4 border-b border-gray-100 pb-6">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-gray-200 rounded-xl shrink-0"></div>
            <div className="space-y-2"><div className="h-8 bg-gray-200 rounded w-48"></div><div className="h-4 bg-gray-200 rounded w-96 hidden sm:block"></div></div>
          </div>
          <div className="h-10 bg-gray-200 rounded-xl w-40"></div>
        </div>

        {/* Skeleton Desktop */}
        <div className="hidden lg:block bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="h-16 border-b border-gray-100 bg-gray-50/50"></div>
          {Array(4).fill(0).map((_, i) => (
            <div key={i} className="flex items-center justify-between p-6 border-b border-gray-50">
              <div className="flex gap-4 w-[30%]"><div className="w-10 h-10 bg-gray-200 rounded-full"></div><div className="space-y-2 flex-1"><div className="h-4 bg-gray-200 rounded w-3/4"></div><div className="h-3 bg-gray-200 rounded w-1/2"></div></div></div>
              <div className="h-6 bg-gray-200 rounded-full w-24"></div>
              <div className="h-6 bg-gray-200 rounded-full w-20"></div>
              <div className="h-8 bg-gray-200 rounded w-8"></div>
            </div>
          ))}
        </div>

        {/* Skeleton Mobile */}
        <div className="lg:hidden flex flex-col gap-4 mt-6">
          {Array(3).fill(0).map((_, i) => (
            <div key={i} className="bg-white rounded-2xl p-5 border border-gray-100 h-48"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto font-sans animate-fade-in relative w-full">
        
        {activeDropdown && (
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setActiveDropdown(null)}
          ></div>
        )}

        {/* CABEÇALHO */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4 border-b border-gray-100 pb-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-teal-50 flex items-center justify-center shrink-0 border border-teal-100/50">
              <Users className="w-6 h-6 md:w-7 md:h-7" style={{ color: brandColor }} />
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                Equipe Interna
              </h1>
              <p className="text-sm sm:text-base text-gray-500 mt-0.5">
                Gerencie os acessos e permissões dos colaboradores da Real Benefícios.
              </p>
            </div>
          </div>
          <button
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center justify-center px-6 py-3 sm:py-2.5 border border-transparent text-sm font-bold rounded-xl text-white transition-all shadow-md hover:brightness-110 w-full md:w-auto mt-2 md:mt-0"
            style={{ backgroundColor: brandColor }}
          >
            <UserPlus className="w-4 h-4 mr-2" />
            Convidar Membro
          </button>
        </div>

        {/* 🟢 BARRA DE PESQUISA */}
        <div className="bg-white rounded-t-2xl border border-gray-100 border-b-0 p-4 sm:p-5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="relative w-full sm:max-w-md">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="w-4 h-4 text-gray-400" />
            </div>
            <input 
              type="text"
              placeholder="Buscar por nome ou e-mail..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-9 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500 transition-shadow text-gray-900"
            />
          </div>
        </div>

        {/* VIEW DESKTOP */}
        <div className={`hidden lg:block bg-white rounded-b-2xl shadow-sm border border-gray-100 overflow-visible transition-all duration-300 ease-in-out ${activeDropdown ? 'pb-56' : 'pb-0'}`}>
          <div className="overflow-visible">
            <table className="min-w-full divide-y divide-gray-100">
              <thead className="bg-gray-50/50">
                <tr>
                  <th scope="col" className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                    Usuário
                  </th>
                  <th scope="col" className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                    Nível de Acesso
                  </th>
                  <th scope="col" className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-4 text-right text-xs font-bold text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 bg-white">
                
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="px-6 py-12 text-center">
                      <div className="flex flex-col items-center justify-center">
                        <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4">
                          <User className="w-8 h-8 text-gray-400" />
                        </div>
                        <h3 className="text-lg font-bold text-gray-900">Nenhum membro encontrado</h3>
                        <p className="mt-1 text-sm text-gray-500">A pesquisa atual não retornou resultados.</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  currentItems.map((member) => (
                    <tr key={`desktop-${member.id}`} className="hover:bg-gray-50/80 transition-colors relative">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10 rounded-full bg-teal-50 flex items-center justify-center text-teal-700 font-bold border border-teal-100">
                            {member.name ? member.name.charAt(0).toUpperCase() : "?"}
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-bold text-gray-900">
                              {member.name}
                            </div>
                            <div className="text-sm text-gray-500 font-medium">
                              {member.email}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {renderRoleBadge(member.role)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {renderStatusBadge(member.status)}
                      </td>
                      
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <div className="relative flex justify-end text-left w-full h-full">
                          <button 
                            onClick={() => toggleDropdown(member.id)}
                            className={`text-gray-400 hover:text-gray-900 transition-colors focus:outline-none p-1.5 rounded-lg hover:bg-gray-100 ${activeDropdown === member.id ? 'relative z-30 bg-gray-100 text-gray-900' : ''}`}
                          >
                            <MoreVertical className="w-5 h-5" />
                          </button>

                          {activeDropdown === member.id && (
                            <div className="absolute right-0 top-10 mt-2 w-56 bg-white border border-gray-100 rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none animate-fade-in z-40 py-1 overflow-hidden">
                              <button
                                onClick={() => handleEditClick(member)}
                                className="w-full text-left px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 flex items-center transition-colors"
                              >
                                <Edit className="w-4 h-4 mr-2.5 text-gray-400" />
                                Editar Permissões
                              </button>

                              <button
                                onClick={() => handleResetPassword(member.email, member.name)}
                                className="w-full text-left px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 flex items-center transition-colors"
                              >
                                <Key className="w-4 h-4 mr-2.5 text-teal-600" />
                                Enviar Resgate de Senha
                              </button>
                              
                              <button
                                onClick={() => handleToggleStatus(member.id, member.status)}
                                className="w-full text-left px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 flex items-center transition-colors"
                              >
                                {member.status === 'Inativo' ? (
                                  <>
                                    <CheckCircle className="w-4 h-4 mr-2.5 text-green-500" />
                                    Desbloquear Acesso
                                  </>
                                ) : (
                                  <>
                                    <Ban className="w-4 h-4 mr-2.5 text-amber-500" />
                                    Bloquear Acesso
                                  </>
                                )}
                              </button>

                              <div className="border-t border-gray-50 my-1"></div>
                              
                              <button
                                onClick={() => handleDeleteMember(member.id, member.name)}
                                className="w-full text-left px-4 py-2.5 text-sm font-bold text-red-600 hover:bg-red-50 flex items-center transition-colors"
                              >
                                <Trash2 className="w-4 h-4 mr-2.5" />
                                Remover Usuário
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* VIEW MOBILE */}
        <div className="lg:hidden flex flex-col gap-4">
          {currentItems.length === 0 ? (
            <div className="bg-white rounded-2xl p-8 text-center border border-gray-100 shadow-sm flex flex-col items-center mt-2">
              <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4">
                <User className="w-8 h-8 text-gray-400" />
              </div>
              <h3 className="text-lg font-bold text-gray-900">Nenhum membro encontrado</h3>
              <p className="mt-1 text-sm text-gray-500 max-w-sm mx-auto leading-relaxed">
                A pesquisa atual não retornou resultados.
              </p>
            </div>
          ) : (
            currentItems.map((member) => (
              <div key={`mobile-${member.id}`} className="bg-white rounded-b-2xl rounded-t-none lg:rounded-2xl p-5 border border-gray-100 border-t-0 shadow-sm flex flex-col gap-4">
                
                <div className="flex justify-between items-center">
                  {renderRoleBadge(member.role)}
                  {renderStatusBadge(member.status)}
                </div>

                <div className="flex items-center gap-4">
                  <div className="flex-shrink-0 h-14 w-14 rounded-full bg-teal-50 flex items-center justify-center text-teal-700 font-black border border-teal-100 text-xl">
                    {member.name ? member.name.charAt(0).toUpperCase() : "?"}
                  </div>
                  <div className="flex flex-col flex-1 min-w-0">
                    <span className="text-base font-bold text-gray-900 leading-tight truncate">
                      {member.name}
                    </span>
                    <span className="text-sm font-medium text-gray-500 mt-1 truncate">
                      {member.email}
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2 mt-2 pt-4 border-t border-gray-100">
                  <button 
                    onClick={() => handleEditClick(member)}
                    className="flex items-center justify-center gap-2 py-2.5 bg-slate-50 text-slate-700 rounded-xl text-xs font-bold hover:bg-slate-100 transition-colors border border-slate-200 shadow-sm"
                  >
                    <Edit className="w-3.5 h-3.5"/> Editar
                  </button>

                  <button 
                    onClick={() => handleResetPassword(member.email, member.name)}
                    className="flex items-center justify-center gap-2 py-2.5 bg-teal-50 text-teal-700 rounded-xl text-xs font-bold hover:bg-teal-100 transition-colors border border-teal-200 shadow-sm"
                  >
                    <Key className="w-3.5 h-3.5"/> Senha
                  </button>

                  <button 
                    onClick={() => handleToggleStatus(member.id, member.status)}
                    className={`flex items-center justify-center gap-2 py-2.5 rounded-xl text-xs font-bold transition-colors border shadow-sm ${member.status === 'Inativo' ? 'bg-green-50 text-green-700 hover:bg-green-100 border-green-200' : 'bg-amber-50 text-amber-700 hover:bg-amber-100 border-amber-200'}`}
                  >
                    {member.status === 'Inativo' ? <><CheckCircle className="w-3.5 h-3.5"/> Ativar</> : <><Ban className="w-3.5 h-3.5"/> Bloquear</>}
                  </button>

                  <button 
                    onClick={() => handleDeleteMember(member.id, member.name)}
                    className="flex items-center justify-center gap-2 py-2.5 bg-red-50 text-red-700 rounded-xl text-xs font-bold hover:bg-red-100 transition-colors border border-red-200 shadow-sm"
                  >
                    <Trash2 className="w-3.5 h-3.5"/> Excluir
                  </button>
                </div>
                
              </div>
            ))
          )}
        </div>

        {/* 🟢 RODAPÉ DE PAGINAÇÃO GLOBAL (Desktop & Mobile) */}
        {filteredMembers.length > 0 && (
          <div className="p-4 border border-gray-100 bg-white rounded-b-xl lg:rounded-xl mt-0 lg:mt-4 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500 shadow-sm">
            <span className="font-medium text-center md:text-left">
              Mostrando <strong className="text-gray-900">{indexOfFirstItem + 1}</strong> a <strong className="text-gray-900">{Math.min(indexOfLastItem, filteredMembers.length)}</strong> de <strong className="text-gray-900">{filteredMembers.length}</strong> membros
            </span>
            
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full md:w-auto">
              <div className="flex items-center gap-2 bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm w-full sm:w-auto justify-center">
                <span className="font-medium">Itens por página:</span>
                <select 
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  className="bg-transparent border-none font-bold text-teal-600 focus:ring-0 cursor-pointer text-sm outline-none"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
              </div>

              {totalPages > 1 && (
                <div className="flex items-center gap-2 justify-center w-full sm:w-auto">
                  <button 
                    onClick={prevPage}
                    disabled={currentPage === 1}
                    className="p-1.5 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 disabled:opacity-50 transition-colors shadow-sm text-gray-600"
                  >
                    <ChevronLeft className="w-5 h-5" />
                  </button>
                  <span className="text-sm font-bold text-gray-900 px-3 py-1 bg-white border border-gray-200 rounded-lg shadow-sm">
                    {currentPage} / {totalPages}
                  </span>
                  <button 
                    onClick={nextPage}
                    disabled={currentPage >= totalPages}
                    className="p-1.5 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 disabled:opacity-50 transition-colors shadow-sm text-gray-600"
                  >
                    <ChevronRight className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

      </div>

      {/* @ts-expect-error - Mismatch de tipagem do React Portal vs JSX Element */}
      <InviteTeamModal 
        isOpen={isModalOpen} 
        onClose={handleCloseModal}
        memberToEdit={memberToEdit}
      />
    </>
  );
};

export default AdminEquipePage;